<template>
  <div>
    <c-search-box @enter="search">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!-- 조치부서 -->
          <c-dept 
            :plantCd="searchParam.plantCd"
            type="search" 
            label="LBL0001417" 
            name="actionDeptCd" 
            v-model="searchParam.actionDeptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!-- 월(개선 - 요청일 기준 / 즉시조치 - 조치일 기준) -->
          <c-datepicker
            :range="true"
            defaultStart="-2M"
            defaultEnd="2M"
            type="month"
            label="LBL0001470"
            name="actionCompleteRequestDates"
            v-model="searchParam.actionCompleteRequestDates"
          />
        </div>
      </template>
    </c-search-box>
    <c-tab
      type="tabcard"
      align="left"
      :inlineLabel="true"
      :tabItems="tabItems"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :searchParam.sync="searchParam"
          :tabParam.sync="tabParam"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
export default {
  name: 'impr-action-rate',
  data() {
    return {
      searchParam: {
        plantCd: null,
        actionCompleteRequestDates: [],
        actionDeptCd: '',
        actionVendorCd: '',
        actionFlag: 'D',
      },
      tab: 'task',
      tabItems: [
        // 업무별
        { name: 'task', icon: 'task_alt', label: 'LBL0001471', component: () => import(`${'./imprTaskRate.vue'}`) },
        // 요청대상별
        { name: 'rqstDept', icon: 'campaign', label: 'LBL0001472', component: () => import(`${'./imprRqstDeptRate.vue'}`) },
      ],
      tabParam: {
        search: '',
      },
      editable: true,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
    search() {

    },
  }
};
</script>
